export const firebaseConfig = {
	apiKey: 'AIzaSyAQPSUiKF05a7LjgRDrsceh_w-YCVo5uuk',
	authDomain: 'dubainight.firebaseapp.com',
	projectId: 'dubainight',
	storageBucket: 'dubainight.appspot.com',
	messagingSenderId: '962650692270',
	appId: '1:962650692270:web:bbfda89430d13a340aeb3f',
	measurementId: 'G-4T5HHBL1GQ',
};
